import api from "./api";

export function getJobs(page = 1, limit = 10, search = "") {
  return api.get(`/jobs?page=${page}&limit=${limit}&search=${search}`);
}

export function getJobById(id) {
  return api.get(`/jobs/${id}`);
}

export function createJob(data) {
  return api.post("/jobs", data);
}

export function updateJob(job_id, data) {
  return api.put(`/jobs/${job_id}`, data);
}

export function deleteJob(id) {
  return api.delete(`/jobs/${id}`);
}

export function uploadJobs(formData) {
  return api.post("/jobs/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    transformRequest: [(data) => data], // ⭐ important
  });
}